export const NAME = 'ARTICLES';

export const articleFavourite = (store) => store[NAME].favourite.data;
